/**
 * Helpers for judge list/detail (avatar initials, etc.).
 */

/** Two-letter initials from judge name (e.g. "Hon. Jane Doe" -> "JD") */
export function judgeAvatarInitials(judgeName: string | null | undefined): string {
  const name = (judgeName ?? '').trim();
  if (!name) return '?';
  const words = name.split(/\s+/).filter(Boolean);
  if (words.length >= 2) {
    const a = words[words.length - 2].slice(0, 1);
    const b = words[words.length - 1].slice(0, 1);
    return (a + b).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}
